import { Injectable, inject } from '@angular/core';

import type { OrderDocument } from '@asset-solutions/customer-portal/orders/models';
import { HttpService } from '@asset-solutions/shared/http';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  private apiPath = '/documents';
  private httpService = inject(HttpService);

  public getDocumentsForOrder(orderMasterId: number): Observable<OrderDocument[]> {
    return this.httpService.get({ api: `${this.apiPath}/orders/${orderMasterId}` });
  }

  public getDocumentImage(documentId: string): Observable<Blob> {
    return this.httpService.get({
      api: `${this.apiPath}/download/${documentId}`,
      headers: { Accept: 'application/pdf' },
      responseType: 'blob'
    });
  }
}
